import { routeTree } from './routeTree.gen';
import { tanstack_router } from '@photology/tanstack/route';

export function getRouter() {
	return tanstack_router(routeTree);
}
